








































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { useSurvey } from '@/bundles/Survey/composables/useSurvey';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { IQueryObjectParam } from '@/bundles/App/type';
import { debounce } from '@/bundles/App/helpers';

import SurveyListTable from '@/bundles/Survey/components/SurveyListTable.vue';

export default defineComponent({
  name: 'Survey',

  components: {
    SurveyListTable,
  },

  setup() {
    const { fetch, surveys, total, pending, exportToCsv, downloadLoading } = useSurvey();
    const { tableOptions, pageOffset } = usePagination({ sortBy: ['email'], sortDesc: [false] });
    const keyword = ref('');
    const surveyTaken = ref(true);

    const params = computed(() => {
      const queryParams: IQueryObjectParam[] = [
        {
          name: 'skip',
          value: pageOffset.value,
        },
        {
          name: 'take',
          value: tableOptions.value.itemsPerPage,
        },
      ];

      if (keyword.value) {
        queryParams.push({
          name: 'keyword',
          value: keyword.value,
        });
      }

      if (surveyTaken.value) {
        queryParams.push({
          name: 'survey_taken',
          value: true,
        });
      }

      if (tableOptions.value.sortBy?.length) {
        queryParams.push({
          name: 'sort_by',
          value: tableOptions.value.sortBy[0]
        });
      }
      if (tableOptions.value.sortDesc?.length) {
        queryParams.push({
          name: 'sort_desc',
          value: tableOptions.value.sortDesc[0]
        });
      }

      return queryParams;
    });

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      await fetch(params.value);
    }

    function keywordSearch() {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
        return;
      }
      fetchWrapper();
    }

    const searchWrapper = debounce<typeof keywordSearch>(keywordSearch, 500);

    watch(keyword, () => {
      searchWrapper();
    });

    watch(surveyTaken, () => {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
      } else {
        fetchWrapper();
      }
    });

    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });

    function optionsChangeEventHandler(options: ITableOptions) {
      tableOptions.value = { ...options };
    }

    function downloadWrapper() {
      exportToCsv(params.value);
    }

    return {
      surveys,
      total,
      pending,
      downloadLoading,
      tableOptions,
      keyword,
      surveyTaken,
      optionsChangeEventHandler,
      downloadWrapper,
    };
  },
});
